<div class="phone-input-wrapper w-full">
    <!-- Label -->
    <label *ngIf="label" class="phone-label">
        {{ label }}
        <span *ngIf="required" class="required-star">*</span>
    </label>

    <!-- Phone Input -->
    <!-- <ngx-intl-tel-input #phoneInput class="w-full" [phoneValidation]="true" [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="enableAutoCountrySelect" [enablePlaceholder]="enablePlaceholder"
        [searchCountryFlag]="searchCountryFlag" [searchCountryField]="searchCountryField"
        [selectFirstCountry]="selectFirstCountry" [selectedCountryISO]="selectedCountryISO" [maxLength]="maxLength"
        [phoneValidation]="phoneValidation" [separateDialCode]="separateDialCode" [numberFormat]="numberFormat"
        (ngModel)="value" (ngModelChange)="onInputChange($event)" [cssClass]="customCssClass"
        
        [name]="name"></ngx-intl-tel-input> -->
    <form [formGroup]="phoneForm">
        <ngx-intl-tel-input (ngModel)="value" (ngModelChange)="onInputChange($event)" [cssClass]="customCssClass"
            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
            [searchCountryFlag]="true" [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
            [phoneValidation]="true" [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National"
            name="phone" formControlName="phone" #phoneInput></ngx-intl-tel-input>
        <!-- Error Message -->
        <small *ngIf="validationChecker()" class="error-text">
            {{ errorMessage }}
        </small>
    </form>
</div>